import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import AreaChart from "../../../Components/Charts/AreaChart";
import { axInst } from "../../../Components/Login/Service";

const fetchServiceRevenuePenetration = async (body) => {
  try {
    const res = await axInst.post(
      "collbax-service/collbax_service_zone_revenue",
      body,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export default function ServiceRevenuePenetration() {
  const { data, submitted } = useSelector((e) => e.filtersServiceCollabax);

  const {
    data: apiData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["serviceRevenuePenetration", submitted],
    queryFn: () => fetchServiceRevenuePenetration(data),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (isError) return <div>Error loading data</div>;

  // 🔥 Transform API response correctly
  const chartsData = apiData
    ? Object.entries(apiData).map(([title, value]) => {
        const keys = Object.keys(value);
        const prevFY = keys.find((key) => key.startsWith("FY"));
        const currFY = keys.find((key) => key.startsWith("YTD_FY"));

        return {
          title,
          monthlyData: value.Month_wise_revenue || {},
          target: value.Target,
          previousYear: {
            label: prevFY,
            value: prevFY ? value[prevFY] : null,
          },
          ytdActual: currFY
            ? { label: currFY, value: value[currFY] }
            : value.YTD_Actual,
        };
      })
    : [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
      {chartsData.map((chart, index) => {
        let endpoint = "collbax-service/collbax_sso_service_revenue";
        let modalPayload = {};

        const titleLower = chart?.title?.toLowerCase() || "";

        if (
          titleLower.includes("service") &&
          titleLower.includes("revenue") &&
          titleLower.includes("penetration")
        ) {
          endpoint =
            "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { sso_status: "SRP" };
        } else if (titleLower.includes("cpsc")) {
          endpoint =
            "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { sso_status: "CPSC_SCORE" };
        } else if (
          titleLower.includes("revenue") &&
          titleLower.includes("per") &&
          titleLower.includes("veh")
        ) {
          endpoint =
            "collbax-service/collbax_service_sso_operational_efficiency";
          modalPayload = { sso_status: "REV_PER_VECH" };
        } else if (
          (titleLower.includes("tass") || titleLower.includes("taas")) &&
          titleLower.includes("revenue") &&
          (titleLower.includes("percentage") || titleLower.includes("%"))
        ) {
          endpoint = "collbax-service/collbax_sso_service_revenue";
          modalPayload = { Percentage_status: "TASS_PERCENTAGE" };
        } else if (
          (titleLower.includes("%") || titleLower.includes("percentage")) &&
          titleLower.includes("revenue") &&
          titleLower.includes("from") &&
          titleLower.includes("accident")
        ) {
          endpoint = "collbax-service/collbax_sso_service_revenue";
          modalPayload = { Percentage_status: "ACCIDENTAL_PERCENTAGE" };
        } else if (
          (titleLower.includes("tass") || titleLower.includes("taas")) &&
          titleLower.includes("accident") &&
          titleLower.includes("revenue")
        ) {
          endpoint = "collbax-service/collbax_sso_service_revenue";
          modalPayload = { Service_Type: ["Accident"], Partner_Type: ["TASS"] };
        }

        return (
          <AreaChart
            key={index}
            title={chart.title}
            data={chart.monthlyData}
            target={chart.target}
            previousYear={chart.previousYear}
            ytdActual={chart.ytdActual}
            modalEndpoint={endpoint}
            modalPayload={modalPayload}
          />
        );
      })}
    </div>
  );
}
